import React, { useState } from 'react';
import { BookOpen, ChevronDown, HelpCircle } from 'lucide-react';
import { usePublicContent } from '@/lib/content';

export default function SupportPage() {
  const content = usePublicContent();
  const [openId, setOpenId] = useState(null);
  const faq = [...(content.faq || [])]
    .filter((item) => item.enabled !== false)
    .sort((a, b) => (a.sort_order || 0) - (b.sort_order || 0));

  return (
    <div className="max-w-4xl mx-auto animate-fade-in" data-testid="faq-page">
      <div className="mb-8">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-blue-500/10 border border-blue-500/20 text-blue-300 text-xs font-bold uppercase tracking-[0.2em] mb-4">
          <BookOpen className="w-3.5 h-3.5" />
          Hjælp til gæsteportalen
        </div>

        <h1 className="text-3xl font-semibold tracking-tight text-slate-50 mb-2" style={{ fontFamily: "'Outfit', sans-serif" }}>
          Spørgsmål og svar
        </h1>

        <p className="text-sm text-slate-400 max-w-2xl">
          Praktiske svar, lette IT-jokes og ro i systemet, når du skal finde rundt i Molin30.
        </p>
      </div>

      <div className="bg-slate-800/40 border border-slate-700/50 rounded-xl p-4 sm:p-6">
        <div className="flex items-center gap-2 mb-4">
          <HelpCircle className="w-4 h-4 text-blue-400" />
          <h2 className="text-xs font-bold uppercase tracking-[0.2em] text-blue-400">FAQ</h2>
        </div>

        <div className="space-y-3">
          {faq.map((item) => {
            const isOpen = openId === item.id;
            return (
              <div key={item.id} className="rounded-lg border border-slate-700/50 bg-slate-900/30 overflow-hidden">
                <button
                  type="button"
                  onClick={() => setOpenId(isOpen ? null : item.id)}
                  className="w-full min-h-12 flex items-center justify-between gap-3 px-4 py-3 text-left text-sm text-slate-100 hover:bg-slate-800/50"
                  aria-expanded={isOpen}
                >
                  <span>{item.question}</span>
                  <ChevronDown className={`w-4 h-4 text-slate-400 flex-shrink-0 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
                </button>
                {isOpen && (
                  <div className="px-4 pb-4 text-sm text-slate-400 leading-relaxed">
                    {item.answer}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
